import { AbstractControl, FormControl, FormGroup } from "@angular/forms";

import _merge from "lodash/merge";
import { Observable } from "rxjs";
import { merge } from "rxjs/internal/observable/merge";
import { map } from "rxjs/operators";

import { BaseObservableForm } from "../../../../shared-library/forms/base-observable.form";

import { SearchParametersModel } from "../models/search-parameters.model";

export class ContentSearchForm extends BaseObservableForm<SearchParametersModel> {
    public static createForm(
        initialSearchParams: SearchParametersModel,
        emptySearchParams: SearchParametersModel
    ): ContentSearchForm {
        const formGroup = new FormGroup({
            searchTab: new FormControl(initialSearchParams.searchTab),
            searchContext: new FormControl(initialSearchParams.searchContext),

            searchText: new FormControl(initialSearchParams.searchText),
            sortOption: new FormControl(initialSearchParams.sortOption),
            pageNumber: new FormControl(initialSearchParams.pageNumber),
            pageSize: new FormControl(initialSearchParams.pageSize)
        });

        return new ContentSearchForm(formGroup, initialSearchParams, emptySearchParams);
    }

    public get instance(): FormGroup { return this.formInstance; }

    public get searchText(): AbstractControl { return this.getFormControl("searchText"); }
    public get sortOption(): AbstractControl { return this.getFormControl("sortOption"); }
    public get pageNumber(): AbstractControl { return this.getFormControl("pageNumber"); }
    public get pageSize(): AbstractControl { return this.getFormControl("pageSize"); }

    protected constructor(
        formInstance: FormGroup,
        initialSearchParams: SearchParametersModel,
        private emptySearchParams: SearchParametersModel
    ) {
        super(formInstance, initialSearchParams);
    }

    protected bindOnChangeSubscription(): Observable<SearchParametersModel> {
        return merge(
            this.searchText.valueChanges.pipe(map((searchText: string) => ({
                searchText: searchText,
                pageNumber: 1
            }))),
            this.sortOption.valueChanges.pipe(map((sortOption: string) => ({
                searchText: this.initialFormState.searchText,
                sortOption: sortOption,
                pageNumber: 1
            }))),
            this.pageNumber.valueChanges.pipe(map((pageNumber: number) => ({
                searchText: this.initialFormState.searchText,
                pageNumber: pageNumber
            }))),
            this.pageSize.valueChanges.pipe(map((pageSize: number) => ({
                searchText: this.initialFormState.searchText,
                pageNumber: 1,
                pageSize: pageSize
            })))
        ).pipe(
            map(partialModel => this.getFormModel(partialModel))
        );
    }

    protected getFormModel(partialFormModel: any = {}): SearchParametersModel {
        return _merge(new SearchParametersModel(), super.getFormModel(partialFormModel));
    }

    public reset(): void {
        this.formInstance.patchValue(this.emptySearchParams, { emitEvent: false });
    }
}
